import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getApiAction, getSiteId, productAddedMain, postApiAction } from "../../Utils/helper";
import SupportPopup from "../SupportPopup/SupportPopup";
import ComplementryProducts from "../Products/ComplementryProducts";
import { decrementCartCount } from "../../store/action";
import { BASE_URL } from '../../constants';

const Welcome = () => {
  const navigate = useNavigate();
  const [quantity, setQuantity] = useState(0);

  const bannerStyle = {
    backgroundImage: `url(${BASE_URL}/assets/images/welcomBg.png)`,
  };
  const chefBannerStyle = {
    backgroundImage: `url(${BASE_URL}/assets/images/chef_Bg.png)`,
  };
  const welcomBgImageStyle = {
    backgroundImage: `url(${BASE_URL}/assets/images/welcom_bg_image.png)`,
  }; 
  const headingBgStyle = {
    backgroundImage: `url(${BASE_URL}/assets/images/chairs.png)`,
  };
  let tableInfo = useSelector((state) => state.main.tableInfo);
  if (!tableInfo.table_no) {
    tableInfo = JSON.parse(localStorage.getItem('bookingData'));
  }

  const handleClick = () => {
    navigate("/"+ getSiteId() +"/category-menu");
  };
  const [chefData, setChefData] = useState({});  
  const dispatch = useDispatch();

  useEffect(() => {
    return async () => {
      let countryCodeData = await getApiAction('products/chef-special', {}, 0, dispatch);
      setChefData(countryCodeData?.product);
      const cartValue =
      countryCodeData?.product?.cart_value &&
      countryCodeData?.product?.cart_value.length > 0
      ? countryCodeData?.product?.cart_value[0].quantity
      : 0;
      setQuantity(cartValue);
    }
  },[])

  const [showComplementry, setShowComplementry] = useState(false);
  const [showSupport, setShowSupport] = useState(false);
  const closePopup = () => {
    setShowSupport(false);
    setShowComplementry(false);
  };

  const productAddHandleClick = async (name, id, price, comment) => {
    let resp = await productAddedMain(name, id, price, comment, 0, 0, dispatch)
    setQuantity(1);
    
    if (chefData?.complements?.length) {
      setTimeout(() => {
        setShowComplementry(true);
      }, 1000);
      setTimeout(() => {
        setShowComplementry(false);
      }, 30000);
    }                  
  }

  const incrementQuantity = async (id,quantity,comment) => {
    setQuantity(quantity + 1);
    let postData = {
      product_id: id,
      quantity: quantity + 1,
      notes: comment,
    };
    let resp = await postApiAction("cart/update", postData,  0, dispatch);
    // dispatch(incrementCartCount());
  };

  const decrementQuantity = async (id,quantity,comment) => {
    if (quantity > 0) {
      setQuantity(quantity - 1);
      let postData = {
        product_id: id,
        quantity: quantity - 1,
        notes: comment,
      };
      let resp = await postApiAction("cart/update", postData,  0, dispatch);
      if (quantity == 1) {
        dispatch(decrementCartCount());
      }
    }
  };

  return (
    <div>
      {showSupport && <SupportPopup closePopup={closePopup}/>}
      <div className="wrapper welcomeSec">
       <div className="mininner_welcomeSec">
       <div className="inner_bannerArea" style={bannerStyle}>
          <div className="logo">
            <a href="#">
              <img src={`${BASE_URL}/assets/images/logo2.png`} alt="" />
            </a>
          </div>
          <div className="contactBox">
            <h2>¡<span style={{textTransform: 'capitalize'}}>{JSON.parse((localStorage.getItem('bookingData'))).name}</span>, nos alegra tu visita!</h2>
            <p>Tu mesa asignada</p>
            <span className="number" style={headingBgStyle}>{ tableInfo?.table_no || 'N-A'}</span>
            <div className="subText d-flex justify-content-between align-items-center flex-wrap align-items-center">
              <p>
                No. de personas: <span>{ tableInfo?.adults_count || 0} adultos, { tableInfo?.child_count || 0} niños</span>
              </p>
              <ul className="d-flex flex-wrap">
                <li>
                  <Link to={`/${getSiteId()}/login?edit=true`}>
                    <img src={`${BASE_URL}/assets/images/edit.png`} alt="" />
                  </Link>
                </li>
                <li>
                  <a  onClick={() => setShowSupport(true)}>
                    <img
                      className="healpIcn"
                      src={`${BASE_URL}/assets/images/help.png`}
                      alt=""
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {chefData && <div className="chef_section" style={chefBannerStyle}>
          {showComplementry && (
            <ComplementryProducts 
            itemData={chefData}
            closePopup={closePopup} />
          )}
            <div className="container_lg">
              {/* <h3>
                <span>{chefData.name}</span>
              </h3> */}
              <div className="heading innerHead">
                  <h2 className="head" onClick={handleClick}><span><a href="#" className="orderList">¡Ordena aquí! <img
                      className="healpIcn"
                      src={`${BASE_URL}/assets/images/hand.png`}
                      alt=""
                    /></a></span></h2>
              </div>
              <div className="image">
                <div className="bg_image" style={welcomBgImageStyle}>
                {/* <img src="assets/images/welcom_img1.png" alt="" /> */}
                  <img src={chefData.default_image} alt="" />
                </div>
               
              </div>
            </div>
            <div className="container">
              <div className="subText d-flex flex-wrap justify-content-between">
                <div className="text">
                <h3>
                  <span>{chefData.name}</span>
                </h3>
                  <p>
                    {chefData.description}
                  </p>
                </div>
                <div>
                <div className="quantity-box">
                <button 
                  onClick={() => productAddHandleClick(chefData.name, chefData.id, chefData.price, '',)}
                   className="addBtn">
                    Agregar
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                    >
                      <path
                        d="M38 26H26V38H22V26H10V22H22V10H26V22H38V26Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                    {/*(quantity && (
                      <div className="number">
                        <span
                          className="minus"
                          onClick={() =>
                            decrementQuantity(chefData.id, quantity, "")
                          }
                        >
                          {quantity > 1 ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M4.16699 10.8337H15.8337V9.16699H4.16699V10.8337Z"
                                fill="#fff"
                              />
                            </svg>
                          ) : (
                            <>
                              {<svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M13.3337 7.5L13.3337 15.8333L6.66699 15.8333L6.66699 7.5L13.3337 7.5ZM12.0837 2.5L7.91699 2.5L7.08366 3.33333L4.16699 3.33333L4.16699 5L15.8337 5V3.33333L12.917 3.33333L12.0837 2.5ZM15.0003 5.83333L5.00033 5.83333L5.00033 15.8333C5.00033 16.75 5.75033 17.5 6.66699 17.5H13.3337C14.2503 17.5 15.0003 16.75 15.0003 15.8333L15.0003 5.83333Z"
                                fill="#fff"
                              />
                            </svg>}
                            </>
                          )}
                        </span>
                        <input type="text" value={quantity} />
                        <span
                          className="plus"
                          onClick={() =>
                            incrementQuantity(chefData.id, quantity, "")
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M15.8337 10.8337L10.8337 10.8337L10.8337 15.8337H9.16699L9.16699 10.8337H4.16699L4.16699 9.16699H9.16699V4.16699L10.8337 4.16699V9.16699L15.8337 9.16699V10.8337Z"
                              fill="#fff"
                            />
                          </svg>
                        </span>
                      </div>
                    )) || (
                  <button 
                  onClick={() => productAddHandleClick(chefData.name, chefData.id, chefData.price, '',)}
                   className="addBtn">
                    Agregar
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                    >
                      <path
                        d="M38 26H26V38H22V26H10V22H22V10H26V22H38V26Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                    )*/}
                    </div>
                </div>
              </div>
              {/* <button onClick={handleClick} className="btn goToBtn">
                Ir al menú
              </button> */}
            </div>
        </div>}
        {/* {!chefData && 
            <div className="container">
              <button onClick={handleClick} className="btn goToBtn">
                Ir al menú
              </button>
            </div>
        } */}
       </div>
      </div>
    </div>
  );
};

export default Welcome;
